import { useMemo } from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Icon } from '../../../../../components/common/icon/Icon';

const MAX_PAGE_WIDTH = 512;
const SWIPER_LEFT_PADDING = 32;
const SLIDE_WIDTH = 200;
const SLIDE_GAP = 16;

export const Section2 = () => {
  // 페이지 가로 너비에 따라서 한 Page에서 보여줄 Slide 수 계산
  const slidePerView = useMemo<number>(() => {
    if (document.documentElement.clientWidth > MAX_PAGE_WIDTH) {
      return MAX_PAGE_WIDTH / (SWIPER_LEFT_PADDING + SLIDE_WIDTH + SLIDE_GAP);
    }

    return document.documentElement.clientWidth / (SWIPER_LEFT_PADDING + SLIDE_WIDTH + SLIDE_GAP);
  }, [document.documentElement.clientWidth]);

  return (
    <Container>
      <Title>{'플루바 마켓에서\n판매하면 좋은점이 뭘까요?'}</Title>
      <CustomSwiper
        slidesPerView={slidePerView}
        // 슬라이드 사이의 간격
        spaceBetween={16}
      >
        <CustomSwiperSlide>
          <Card>
            <Icon name={'Free5'} width={48} height={48} />
            <CardText>{'직거래 매물에 올리는\n수수료 무료!'}</CardText>
          </Card>
        </CustomSwiperSlide>
        <CustomSwiperSlide>
          <Card>
            <Icon name={'Eye1'} width={48} height={48} />
            <CardText>{'매일 1~2천명 이상\n직거래 매물을 구경해요!'}</CardText>
          </Card>
        </CustomSwiperSlide>
        <CustomSwiperSlide>
          <Card>
            <Icon name={'FlagSell1'} width={48} height={48} />
            <CardText>{'판매 신청하면\n당일부터 판매 가능!'}</CardText>
          </Card>
        </CustomSwiperSlide>
      </CustomSwiper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding: 32px 16px;
  gap: 24px;

  align-self: stretch;
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const Title = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const CustomSwiper = styled(Swiper)`
  width: calc(100% + 32px);

  padding: 0px 32px;

  transform: translateX(-16px);

  gap: 16px;
`;

const CustomSwiperSlide = styled(SwiperSlide)`
  width: 200px;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  cursor: pointer;
`;

const Card = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 24px var(--radius-large, 16px);
  gap: var(--radius-medium, 8px);

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const CardText = styled.pre`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
`;
